import { CompleteAddress } from '@dreryk/address-common-api';
import {
   HealthcareFacilityUpdateCommand,
   HealthcareOrganizationPartContactData,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { UnitRegon } from '@dreryk/regon-common-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';

import {
   HealthcareFacilityUpdateFormBean,
   HealthcareFacilityUpdateFormController,
} from './HealthcareFacilityUpdateForm';

type HealthcareFacilityUpdateModalConfirmButtonProps = Pick<HealthcareFacilityUpdateFormController, 'handleSubmit'> & {
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityUpdateModalConfirmButton = (
   props: HealthcareFacilityUpdateModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: updateHealthcareFacility } = useCqrsCommand<void, HealthcareFacilityUpdateFormBean>(
      (parameters) => {
         const command = new HealthcareFacilityUpdateCommand();
         command.id = parameters.id;
         command.name = parameters.name;
         command.regon = UnitRegon.of(parameters.regon!);
         command.usingHealthcareOrganizationAddressData = parameters.usingParentAddressData;
         if (!parameters.usingParentAddressData) {
            command.address = Choice.of<CompleteAddress>(
               CompleteAddress.builder()
                  .withTown(parameters.city!)
                  .withPostcode(parameters.postcode!)
                  .withStreet(parameters.street)
                  .withBuilding(parameters.house!)
                  .withFlat(parameters.flat)
                  .build()
            );
         }

         command.usingHealthcareOrganizationContactData = parameters.usingParentContactData;
         if (!parameters.usingParentContactData) {
            command.contactData = Choice.of<HealthcareOrganizationPartContactData>({
               phoneNumber: parameters.phoneNumber!,
               emailAddress: Choice.withUseDefaultIfNull(parameters.emailAddress),
            });
         }

         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(healthcareOrganizationTranslationKeys.healthcareFacilityDataChanged);
            props.onDataChanged();
         },
      }
   );

   return (
      <ModalConfirmButton label={commonTranslationKeys.save} onClick={props.handleSubmit(updateHealthcareFacility)} />
   );
};
